import React, { useState, useEffect } from "react";
import VideoRecorder from "react-video-recorder";
import logo from "../assets/images/logo.png";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import Axios from "axios";
import {  HRinitialScreening, PostAttemptedQuestions, TestSaveCandidateRecordedVideo,GetInterviewDetailWithOutQuns } from "../apiconstants/constants";
import LoadingSpinner from "../helpers/loadingspinner";
import parse from 'html-react-parser';
import DOMPurify from "dompurify";
import NoMobileAccess from "../nomobileaccess";

const OnlineTest = () => {
  const [recordedVideoUrl, setRecordedVideoUrl] = useState(null);
  const [showQuestions, setShowQuestions] = useState(false);
  const [recordingStopped, setRecordingStopped] = useState(false);
  const [startTime, setStartTime] = useState(null); 
  const [timerId, setTimerId] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState(); 
  const [data, setData] = useState({});
  const [questionsData, setQuestionsData] = useState({});
  const [jobRoleId, setJobRoleId] = useState();
  const [showScreen, setShowScreen] = useState(false);
  const [showInstructions, setShowInstructions] = useState(true); 
  const search = useLocation().search;
  const [jobRoles, setJobRoles] = useState([]);
  const [isActive, setisActive] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [showThankYouMessage, setShowThankYouMessage] = useState(false); 
  const [isRecordingInProgress, setIsRecordingInProgress] = useState(false); 
  const [showWaitMessage, setShowWaitMessage] = useState(false);
  const [endDateMessage, setEndDateMessage] = useState(false);
  const [startDateMessage, setStartDateMessage] = useState(false);
  const [visibilityChangeCount, setVisibilityChangeCount] = useState(0);
  const GuiId = new URLSearchParams(search).get("GuiId");
  const [cameraStarted, setCameraStarted] = useState(false);
  const [MAX_RECORDING_TIME, setMaxRecordingTime] = useState(null);


  const validateGuiId = async () => {
    try {
      const GetapiUrl = `${GetInterviewDetailWithOutQuns.APIURL}/${GuiId}`;
      const response = await Axios.get(GetapiUrl);
      setData(response.data[0]);
      setisActive(response.data[0].isActive);
      // const jobRoleId = response.data[0].jobRoleID
      // setJobRoleId(jobRoleId);
      const startDate = (response.data[0].startDate);
      const endDate = (response.data[0].endDate);
      setMaxRecordingTime(response.data[0].time * 60 * 1000)
      setTimeRemaining(response.data[0].time *  60  * 1000)
      const currentDate = new Date();
      const parsedStartDate = new Date(startDate);
      parsedStartDate.setHours(0, 0, 0, 0); // Set to beginning of day
      const parsedEndDate = new Date(endDate);
      parsedEndDate.setHours(23, 59, 59, 999); // Set to end of day

      if (currentDate < parsedStartDate) {
        console.log("Before start date");
        setStartDateMessage(true);
        setShowScreen(false);
      } else if (currentDate > parsedEndDate) {
        setEndDateMessage(true);
        setShowScreen(false);
      } else {
        setShowScreen(true);
      }

    } catch (error) {
      console.error("Error: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during validation",
        showConfirmButton: false,
        timer: 5000,
      });
    } finally {
      setIsLoading(false); 
    }
  };

  useEffect(() => {
    validateGuiId();
  }, []);


  const handleVisibilityChange = () => {
    if (!recordingStopped && !showThankYouMessage) {
      setVisibilityChangeCount(prevCount => prevCount + 1);
      if (visibilityChangeCount === 1) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Recording will be stopped when you change tab/window. Please do not switch tabs.",
          showConfirmButton: false,
          timer: 5000,
        });
      } else if (visibilityChangeCount === 2) {
        stopRecordingWithDelay();
      }
    }
  };
   const [isOpen, setIsOpen] = useState(false);  // Initially open the first accordion item
  
    const toggleAccordion = () => {
      setIsOpen(!isOpen);
    };
  const stopRecordingWithDelay = () => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "You switched tabs again. Recording is now stopping and submitting video.",
      showConfirmButton: false,
      timer: 5000,
    }).then(() => {
      setShowWaitMessage(true);
      setTimeout(() => {
        stopRecording(false);
      }, 3000); // 3 seconds delay
    });
  };
  

  useEffect(() => {
    if (isRecordingInProgress && !recordingStopped) {
      document.addEventListener("visibilitychange", handleVisibilityChange);
    } else {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    }

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isRecordingInProgress, recordingStopped,visibilityChangeCount]);

  useEffect(() => {
    if (startTime && !recordingStopped) {
      const interval = setInterval(() => {
        const elapsedTime = Date.now() - startTime;
        setTimeRemaining(MAX_RECORDING_TIME - elapsedTime);
        if (elapsedTime >= MAX_RECORDING_TIME) {
          stopRecording(true);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [startTime, recordingStopped]);

  const handleCameraOn =async () => {
    setCameraStarted(true);
    startRecording();
    setShowInstructions(false);
    setStartTime(Date.now());
    
    try {
      const GetapiUrl = `${HRinitialScreening.APIURL}/${GuiId}`;
      const response = await Axios.get(GetapiUrl);
      setQuestionsData(response.data[0]);
  
    } catch (error) {
      console.error("Error: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during validation",
        showConfirmButton: false,
        timer: 5000,
      });
    } finally {
      setIsLoading(false); 
    }

    setShowQuestions(true);
    setIsRecordingInProgress(true);
  };

  const startRecording = () => {

    const id = setTimeout(() => {
      stopRecording(true);
    }, MAX_RECORDING_TIME);
    setTimerId(id);
  };

  const startTest = async () => {
    // setShowQuestions(true);
   // setShowInstructions(false); // Hide instructions when the test is started
   // setStartTime(Date.now()); // Set the start time when the test is started
   // setIsRecordingInProgress(true);
  
   Swal.fire({
    position: "center",
    icon:'info',
    text: "Please turn on camera to start the test",
    showConfirmButton: false,
    timer: 2000,
  });

  };
  const stopRecording = () => {
    setRecordingStopped(true);
    setIsRecordingInProgress(false);
  };
  
  const handleRecordingComplete = async (videoBlob) => {
    const videoUrl = URL.createObjectURL(videoBlob);
    setRecordedVideoUrl(videoUrl);
    setShowWaitMessage(true);
    setIsLoading(false);

    setRecordingStopped(true);
    setIsRecordingInProgress(false);
    clearTimeout(timerId);
    setTimeout(async () => {
      setShowWaitMessage(false); 
      setIsLoading(true); 

      try {
        const formData = new FormData();
        formData.append("guid", GuiId);
        formData.append("CandidateName", data?.name);
        formData.append("videoUrl", videoUrl);
        formData.append("video", videoBlob, "recording.webm");
        const response = await Axios.post(
          TestSaveCandidateRecordedVideo.APIURL,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setIsLoading(false);

        // if (response.status === 200) {
          if (response.data == 'Video uploaded successfully') {

      
          await  submitQuestions();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Video uploaded successfully",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            setShowThankYouMessage(true); // Show thank you message after success alert
          });
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Failed to upload video",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.error("Error uploading video: " + error);
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "An error occurred during video upload",
          showConfirmButton: false,
          timer: 5000,
        });
        setIsLoading(false);
      }
    }, 4000); // Delay of 5 seconds
  };
console.log("nane",data?.name)
  const submitQuestions = async () => {
    try {
      const params = {
        guid: GuiId,
        questions: questionsData.questions,
        jobRoleId: data?.jobRoleID,
        // candidateName:data.name
      };

      await Axios.post(PostAttemptedQuestions.APIURL, params);
    } catch (error) {
      console.error("Error submitting questions: " + error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "An error occurred during questions submission",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
   const handleSubmission = () => {
    if (!cameraStarted) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please start the camera recording before submitting.",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
  
    setRecordingStopped(true);
    setIsRecordingInProgress(false);
  };
  
  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  if (isLoading) {
    return (
      <center>
        <LoadingSpinner />
      </center>

    );
  }

  if (showWaitMessage) {
    return (

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <h3>Please don't close the window until you are notified that your video has been successfully saved. </h3>
        </div>
      </div>

    )
  }

  if (startDateMessage) {
    return (

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <h3>Please wait untill Interview.Reach out to <b style={{ color: "#00a7ac" }}>mailto:hire@knackhook.com</b> if you have any questions.</h3>
        </div>
      </div>

    )
  }
  if (endDateMessage) {
    return (

      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <h3>Link has Expired.Please reach out to <b style={{ color: "#00a7ac" }}>mailto:hire@knackhook.com</b> if you have any questions.</h3>
        </div>
      </div>

    )
  }

  return (
    <NoMobileAccess>
      {showScreen && isActive ? (
        <div style={{ flexDirection: "row" }}>
          {recordingStopped ? (
            showThankYouMessage ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <div className="container" style={{ textAlign: "center" }}>
                  <h4>Thank you for attending the interview, please reach out to <b style={{ color: "#00a7ac" }}>mailto:hire@knackhook.com</b> if you have any questions. Now you can close the browser window.</h4>
                </div>
              </div>
            ) : (
              <></>
            )
          ) : (
            <div className="container mt-2 pb-2">
              {/* <h2 style={{ color: "#00a7ac" }} className="text-center">
                <img src={logo} alt="Company Logo" height={70} />
              </h2> */}
              {/* <div className="row">

                <div className="col-sm-12 col-lg-6 col-xl-6 col-md-12">
                  <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
                    <p className="text-para">Name: <b>{data.name}</b></p>
                    <p className="text-para">Email: <b>{data.email}</b></p>
                  </div>
                </div>
                <div className="col-sm-12 col-lg-6 col-xl-6 col-md-12">
                  <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
                    <p className="text-para">Technology: <b>{data.technology}</b></p>
                    <p className="text-para">Time Limit: <b>{formatTime(timeRemaining)}</b></p>
                  </div> 
                   </div>
              </div> */}
              <div className="card shadow-lg mt-2 p-2" style={{ border: "none" }}>
             
                <div className="row">
                 
                <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                <div className="card shadow-lg p-3 text-center" style={{border:'none',backgroundColor:'#00a7ac',color:'#fff'}}>
    <p className="text-para">Name: <b>{data.name}</b></p>
    <p className="text-para">Email: <b>{data.email}</b></p>
    <p className="text-para">Technology: <b>{data.technology}</b></p>
    <p className="text-para">Time Limit: <b>{formatTime(timeRemaining)}</b></p> 
    </div>
                    <div>
                      {showInstructions && (
                       <div className="mt-5">
                       <div className="accordion mt-3 shadow-lg" id="accordionExample">
                         <div className="accordion-item">
                           <h2 className="accordion-header" id="headingThree">
                             <button
                               className="accordion-button"
                               type="button"
                               onClick={toggleAccordion} // Toggles the collapse on button click
                               aria-expanded={isOpen ? "true" : "false"} // Dynamically update the expanded state
                               aria-controls="collapseThree"
                               style={{ fontWeight: 'bold', paddingRight: '30px', backgroundColor: '#fff', color: '#00a7ac' }}
                             >
                               Online Assessment Instructions and Consent
                             </button>
                           </h2>
                           <div
                             id="collapseThree"
                             className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`} // Add 'show' class when open
                             aria-labelledby="headingThree"
                             data-bs-parent="#accordionExample"
                           >
                             <div className="accordion-body">
                             <h5 style={{fontSize:15 }}><b>  1.Webcam & Consent:</b> </h5>
                            <ul style={{ listStyle: 'none',padding:0}}>
                            <li className="text-para" style={{fontSize:15}}>                       
                               <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                               Keep your webcam ON during the test for integrity.
                            </li>
                            <li className="text-para" style={{fontSize:15}}>                                <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 18, color: "#00a7ac", marginRight: 10 }}></i>
                               Your video (image & audio) will be recorded for assessment purposes.
                            </li>
                            </ul>
                            <h5 style={{fontSize:15 }}><b>  2.Data Privacy</b> </h5>
                            <ul style={{ listStyle: 'none',padding:0}}>
                            <li className="text-para" style={{fontSize:15}}>     
                               <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                               Videos are securely stored and will be deleted once the job post is closed.
                            </li>
                            <li className="text-para" style={{fontSize:15}}> 
                               <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                               Used only for evaluating your test performance at KnackHire.
                            </li>
                            </ul>
                            <h5 style={{ fontSize: 15 }}>
                            <b> 3. Submission Rules:</b>
                            </h5>
                            <ul style={{ listStyle: 'none',padding:0}}>
                            <li className="text-para" style={{ fontSize: 15 }}>
                            <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                            One attempt only – ensure all answers are completed before submitting.
                            </li>
                            <li className="text-para" style={{ fontSize: 15 }}>
                            <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                            On clicking the <b>Start Answering</b> button, your answer will be recorded, and your score will be based on that recorded answer only.
                            </li>
                            <li className="text-para" style={{ fontSize: 15 }}>
                            <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                            If you want the AI to read the question aloud, click on the <b>Read Question</b> button.
                            </li>
                            <li className="text-para" style={{ fontSize: 15 }}>
                            <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                            To move to the next question, click on the <b>Next Question</b> button.
                            </li>
                            <li className="text-para" style={{ fontSize: 15 }}>
                            <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                            Click "Submit" to successfully complete the test.
                            </li>
                            </ul>
                            <h5 style={{fontSize:15 }}><b> 4.Malpractice Policy:</b> </h5>
                            <ul style={{ listStyle: 'none',padding:0}}>
                            <li className="text-para" style={{fontSize:15}}>                                <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                               Any malpractice (tab switching, googling, copy-pasting) will lead to automatic submission.
                            </li>
                            </ul>
                            <h5 style={{fontSize:15 }}><b> 5.Test Timing:</b> </h5>
                            <ul style={{ listStyle: 'none',padding:0}}>
                            <li className="text-para"style={{fontSize:15}}>                                <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                               Timer starts once you begin. Test auto-submits when time ends.
                            </li>
                            <li className="text-para" style={{fontSize:15}}>                                <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                               Do not close the window until you see confirmation of video submission. 
                            </li>
                            </ul>
                            <h5 style={{fontSize:15 }}><b>  6.Device Usage:</b> </h5>
                            <ul style={{ listStyle: 'none',padding:0}}>
                            <li className="text-para" style={{fontSize:15}}>                                <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                               Use only your device’s built-in webcam, microphone & keyboard. No external devices.
                            </li>
                            <li className="text-para" style={{fontSize:15}}>                                <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                               No earphones/earbuds allowed.                                                            
                            </li>
                            </ul>
                            <h5 style={{fontSize:15 }}><b>  7.Introduction Requirement:</b> </h5>
                            <ul style={{ listStyle: 'none',padding:0}}>
                            <li className="text-para"style={{fontSize:15}}>                                <i className="fa fa-angle-double-right list-circle" style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}></i>
                               <b> Before starting, introduce yourself (Name, Experience, Core Skills, Recent Projects).<br></br>
                               📌 Follow these guidelines to ensure a smooth assessment process. Good luck! 🚀</b>                            
                            </li>
                            </ul>
                             </div>
                           </div>
                         </div>
                       </div>
                       {!showQuestions && (
                      <button
                        onClick={startTest}
                        className="btn btn-primary mt-3"
                        style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: 15, float: "right" }}
                      >
                        Start Test
                      </button>
                    )}
                       </div>
                      )}

                      {showQuestions && (
                        <div >
                          <h2 style={{ color: "#00a7ac", textAlign: "center" }}>Interview Questions</h2>
                          <hr />
                          <p className="text-para" style={{fontSize:15}}>
                            <b> Please provide a brief introduction about yourself, including your Name, Experience, core technical skills, and recent project details.</b>
                          </p>
                          <hr style={{ borderColor: "#fff", margin: "5px 0" }} />
                          <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                            {questionsData.questions && questionsData.questions.map((question, index) => (
                              <React.Fragment key={question.questionID}>
                                <li>
                                <div className="commenttt-wrapper">  <span  style={{fontSize:18}}className="text-paraa mr-2">{index + 1}.</span>
                                <span className="text-paraa" style={{fontSize:18}}>{parse(DOMPurify.sanitize(question.questionName))}</span>
                                </div>
                                </li>
                               
                                <hr style={{ borderColor: "#fff", margin: "5px 0" }} />
                              </React.Fragment>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                  <div className="row">
                 
    
</div>
                    <div style={{ height: 100 }}>
                    <VideoRecorder
  onRecordingComplete={handleRecordingComplete}
  onStartRecording={handleCameraOn}
  style={{ height: "10", width: "10px" }} // Adjust height and width as needed
/>

                    </div>
                    <div className="mb-2">
                  {showQuestions && (
                  <div className="mb-3">
                    <button
                      onClick={handleSubmission}
                      disabled={!cameraStarted}
                      className="btn btn-primary mt-3"
                      style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: 15, float: "right" }}
                    >
                      Submit
                    </button>
                  </div>
                )}
                    
                  </div>
                  </div>
                 


                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <div className="container" style={{ textAlign: "center" }}>
            <h4>You have already attempted the interview, please reach out to <b style={{ color: "#00a7ac" }}>mailto:hire@knackhook.com</b> if you have any questions.</h4>
          </div>
        </div>
      )}
     
    </NoMobileAccess>
  );
};

export default OnlineTest;